export default function BarrierScene() {
    return (
        <svg
            data-testid="hero-barrier-scene"
            viewBox="0 0 1600 900"
            preserveAspectRatio="xMidYMax slice"
            className="absolute inset-0 h-full w-full"
            aria-hidden="true"
        >
            <defs>
                <linearGradient id="sc-ground" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0" stopColor="#2B333E" />
                    <stop offset="1" stopColor="#12161B" />
                </linearGradient>
                <linearGradient id="sc-beam" x1="0" y1="0" x2="1" y2="0">
                    <stop offset="0" stopColor="#FFE7C2" stopOpacity="0.45" />
                    <stop offset="1" stopColor="#FFD9A0" stopOpacity="0" />
                </linearGradient>
                <radialGradient id="sc-glow" cx="0.5" cy="0.5" r="0.5">
                    <stop offset="0" stopColor="#58BD33" stopOpacity="0.18" />
                    <stop offset="1" stopColor="#58BD33" stopOpacity="0" />
                </radialGradient>
            </defs>

            {/* backdrop buildings */}
            <rect x="120" y="360" width="260" height="300" fill="#232B35" />
            <rect x="1340" y="300" width="210" height="360" fill="#1F2731" opacity="0.9" />
            <rect x="1190" y="440" width="130" height="220" fill="#1C242D" opacity="0.85" />
            <rect x="420" y="480" width="150" height="180" fill="#1C242D" opacity="0.8" />
            {[0, 1, 2, 3].map((i) => (
                <rect key={`w1-${i}`} x={150 + i * 60} y={400 + (i % 2) * 60} width="16" height="20" fill="#58BD33" opacity="0.35" />
            ))}
            {[0, 1, 2].map((i) => (
                <rect key={`w2-${i}`} x={1370 + i * 60} y={340 + (i % 2) * 70} width="16" height="20" fill="#58BD33" opacity="0.3" />
            ))}

            {/* fog */}
            <ellipse cx="800" cy="660" rx="950" ry="150" fill="#FFFFFF" opacity="0.04" />

            {/* glow behind barrier */}
            <circle cx="1050" cy="600" r="260" fill="url(#sc-glow)" />

            {/* ground */}
            <rect x="0" y="640" width="1600" height="260" fill="url(#sc-ground)" />
            <line x1="0" y1="642" x2="1600" y2="642" stroke="#3A4450" strokeWidth="2" />
            {[0, 1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
                <rect key={i} x={90 + i * 180} y="806" width="90" height="6" rx="3" fill="#39424E" />
            ))}
            {/* stop line */}
            <rect x="880" y="692" width="12" height="98" fill="#58BD33" opacity="0.7" />

            {/* UHF reader post with radio waves */}
            <g>
                <rect x="520" y="560" width="14" height="122" rx="5" fill="#39424E" />
                <rect x="498" y="518" width="58" height="48" rx="9" fill="#242C35" stroke="#3A4450" strokeWidth="2" />
                <circle cx="527" cy="542" r="5" fill="#58BD33">
                    <animate attributeName="opacity" values="1;0.25;1" dur="1.4s" repeatCount="indefinite" />
                </circle>
                {[0, 1, 2].map((i) => (
                    <g key={i} className="uhf-wave" style={{ animationDelay: `${i * 0.6}s` }}>
                        <circle cx="527" cy="542" r="34" fill="none" stroke="#58BD33" strokeWidth="2.5" />
                    </g>
                ))}
            </g>

            {/* ANPR camera post */}
            <g>
                <rect x="1190" y="330" width="12" height="352" rx="5" fill="#39424E" />
                <g transform="rotate(26 1196 352)">
                    <rect x="1136" y="332" width="74" height="42" rx="9" fill="#242C35" stroke="#3A4450" strokeWidth="2" />
                    <rect x="1146" y="342" width="24" height="22" rx="4" fill="#10161B" stroke="#58BD33" strokeWidth="1.5" />
                </g>
                <circle className="cam-flash" cx="1150" cy="366" r="18" fill="#FFFFFF" />
                <circle cx="1196" cy="324" r="4" fill="#58BD33" />
            </g>

            {/* boom barrier */}
            <g>
                <rect x="1014" y="556" width="18" height="128" rx="7" fill="#39424E" />
                <rect x="1000" y="676" width="46" height="14" rx="7" fill="#242C35" />
                <circle cx="1023" cy="556" r="6" fill="#58BD33" />
                <g className="barrier-arm">
                    <rect x="1032" y="586" width="420" height="18" rx="9" fill="#242C35" stroke="#3A4450" strokeWidth="1" />
                    <rect x="1064" y="586" width="52" height="18" rx="4" fill="#58BD33" />
                    <rect x="1184" y="586" width="52" height="18" rx="4" fill="#58BD33" />
                    <rect x="1304" y="586" width="52" height="18" rx="4" fill="#58BD33" />
                </g>
            </g>

            {/* car */}
            <g className="demo-car">
                <polygon points="340,64 560,116 560,150 340,150" fill="url(#sc-beam)" />
                <rect x="40" y="60" width="320" height="72" rx="18" fill="#39424E" />
                <path d="M110 62 L152 20 L262 20 L302 62 Z" fill="#46505C" />
                <rect x="152" y="28" width="52" height="28" rx="4" fill="#151B21" />
                <rect x="214" y="28" width="52" height="28" rx="4" fill="#151B21" />
                <rect x="344" y="72" width="16" height="12" rx="4" fill="#FFE7C2" />
                <rect x="44" y="78" width="14" height="10" rx="3" fill="#FF4444" opacity="0.9" />
                <circle cx="122" cy="134" r="26" fill="#0B0D0F" stroke="#4A5561" strokeWidth="6" />
                <circle cx="292" cy="134" r="26" fill="#0B0D0F" stroke="#4A5561" strokeWidth="6" />
            </g>
        </svg>
    );
}
